import { render, staticRenderFns } from "./NDVBase.vue?vue&type=template&id=1d113de4&"
import script from "./NDVBase.vue?vue&type=script&lang=ts&"
export * from "./NDVBase.vue?vue&type=script&lang=ts&"
import style0 from "./NDVBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1d113de4', component.options)
    } else {
      api.reload('1d113de4', component.options)
    }
    module.hot.accept("./NDVBase.vue?vue&type=template&id=1d113de4&", function () {
      api.rerender('1d113de4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/NDV/NDVBase.vue"
export default component.exports